export const user = state => {
	return state.user;
};

export const token = state => {
	return state.token;
};

export const check = state => {
	return state.user !== null;
};

export const modal = state => {
	return state.modal;
};

export const hasCurlProfile = state => {
	return state.user.hasCurlProfile;
}


// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js